import React from 'react';
import { Button, Divider, Typography } from '@mui/material';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';

const ErrorUnauthenticated = ({ title, view }) => {
  useRUMView(view);
  return (
    <Screen
      header={title}
      subheader="Please sign in to continue."
    >
      <Button href={`/${process.env.PREFIX}/auth?redirect_uri=/${process.env.PREFIX}/apply${window.location.search}`}>
        Sign In
      </Button>
      <Divider />
      <Typography variant="body2">
        Contact Customer Support if you need help accessing your account.
      </Typography>
      <Button
        variant="text"
        size="medium"
        href="tel:+18558085861"
      >
        (855) 808-5861
      </Button>
    </Screen>
  );
};

export default ErrorUnauthenticated;
